"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";
import type { MegaMenuFeaturedImage as FeaturedImageType, MegaMenuCTA } from "@/lib/navigation";
interface MegaMenuFeaturedImageProps {
  image: FeaturedImageType;
  cta?: MegaMenuCTA;
  onClose: () => void;
}
export function MegaMenuFeaturedImage(t0) {
  const $ = _c(16);
  const {
    image,
    cta,
    onClose
  } = t0;
  let t1;
  if ($[0] !== image.alt || $[1] !== image.src) {
    t1 = <Image src={image.src} alt={image.alt} fill={true} className="object-cover" sizes="280px" />;
    $[0] = image.alt;
    $[1] = image.src;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <div className="relative aspect-[4/3] rounded-xl overflow-hidden bg-zinc-100">{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const imageContent = t3;
  let t4;
  if ($[6] !== image.href || $[7] !== imageContent || $[8] !== onClose) {
    t4 = image.href ? <Link href={image.href} onClick={onClose} className="block group">{imageContent}</Link> : imageContent;
    $[6] = image.href;
    $[7] = imageContent;
    $[8] = onClose;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== cta || $[11] !== onClose) {
    t5 = cta && <Link href={cta.href} onClick={onClose} className={cn("relative overflow-hidden rounded-xl p-4", "bg-gradient-to-br from-primary to-[#3a5434]", "text-white", "group cursor-pointer", "hover:shadow-lg transition-all duration-200")}><div className="flex items-center justify-between gap-3"><div className="flex-1 min-w-0"><div className="font-semibold text-base">{cta.label}</div>{cta.description && <div className="text-white/80 text-sm mt-0.5">{cta.description}</div>}</div><ArrowRight className="w-5 h-5 flex-shrink-0 group-hover:translate-x-1 transition-transform" /></div></Link>;
    $[10] = cta;
    $[11] = onClose;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t4 || $[14] !== t5) {
    t6 = <div className="flex flex-col gap-4">{t4}{t5}</div>;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}